import { render, staticRenderFns } from "./project-sort-button.vue?vue&type=template&id=0d480e50&scoped=true&"
import script from "./project-sort-button.vue?vue&type=script&lang=ts&"
export * from "./project-sort-button.vue?vue&type=script&lang=ts&"
import style0 from "./project-sort-button.vue?vue&type=style&index=0&id=0d480e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d480e50",
  null
  
)

export default component.exports